import PropTypes from "prop-types";
import { Button, Spinner } from "react-bootstrap";
import useUpdateResource from "services/useUpdateResource";

const ResendInvitation = ({ subscriber }) => {
  const { isLoading, updateResource } = useUpdateResource({
    apiVersion: "v1",
    url: `/invitations/${subscriber?.invitation?.id}/resend`,
    hasURLOrgPrefix: false,
    toastConfig: {
      success: {
        title: "Success",
        description: `Invitation was successfully sent to ${subscriber.firstName} ${subscriber.lastName}`,
      },
      error: {
        title: "Error Resending invitation",
        description:
          "There was an error while resending the invitation. Please try again.",
      },
    },
  });

  if (!!subscriber?.invitation?.subscriberJoinedAt) return <span />;

  return (
    <Button
      size="sm"
      className="me-1"
      variant="outline-dark"
      disabled={isLoading}
      onClick={() => updateResource({})}
    >
      {isLoading ? (
        <Spinner size="sm" animation="border" />
      ) : (
        <span translate="no" className="material-symbols-outlined md-16">
          refresh
        </span>
      )}
    </Button>
  );
};

ResendInvitation.propTypes = {
  subscriber: PropTypes.object.isRequired,
};

export default ResendInvitation;
